import { render, staticRenderFns } from "./CustomerOriginAndIpCell.vue?vue&type=template&id=6dfa81d7&"
import script from "./CustomerOriginAndIpCell.vue?vue&type=script&lang=js&"
export * from "./CustomerOriginAndIpCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports